export default __webpack_public_path__ + "static/20km-b861cfe5201089131323004dfdea1f2c.png";